<template>
    <el-row id="collectData">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnBack="true" @btnBackClick="handleBackClick" />
        <div style="width: 100%;margin-top:30px;">
            <el-form>
                <el-row>
                    <el-col :span="12" style="position: relative;margin-top: 30px">
                        <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">采集对象</span>
                        <el-checkbox-group v-model="channelCheckList" style="display: inline-block">
                            <el-checkbox label="INSTITUTION" style="color: #606266;">机构</el-checkbox>
                            <el-checkbox label="HCP" style="color: #606266;">HCP</el-checkbox>
                            <el-checkbox label="RETAILSTORE" style="color: #606266;">门店</el-checkbox>
                            <el-checkbox label="DISTRIBUTOR" style="color: #606266;">经销商</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                    <el-col :span="12" style="text-align: left;margin-top:20px;">
                        <span style="font-weight: bold;display: inline-block;width: 70px">销售人员</span>
                        <el-select v-model="owner_id" placeholder="请选择" style="width: calc(100% - 90px)">
                            <el-option v-for="item in peopleList" :key="item.user_id" :label="item.alias"
                                :value="item.user_id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" style="text-align: left;margin-top:20px;">
                        <span style="font-weight: bold;display: inline-block;width: 70px">客户区域</span>
                        <el-select v-model="province_id" placeholder="请选择" @change="getCityList"
                            style="width: calc(50% - 45px)">
                            <el-option v-for="item in provinceList" :key="item.province_id" :label="item.province_name"
                                :value="item.province_id">
                            </el-option>
                        </el-select>
                        <el-select v-model="city_id" placeholder="请选择" style="width: calc(50% - 45px)">
                            <el-option v-for="item in cityList" :key="item.city_id" :label="item.city_name"
                                :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" style="text-align: left;margin-top:20px;">
                        <span style="font-weight: bold;display: inline-block;width: 70px">客户名称</span>
                        <el-input type="text" v-model="customer_name" placeholder="请输入采集客户名称"
                            style="width: calc(100% - 90px)">
                        </el-input>
                    </el-col>

                </el-row>
            </el-form>
            <el-row style="margin-top:80px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
            </el-row>

            <div style="margin-bottom: 20px">
                <el-row style="margin-top: 20px;">
                    <el-col :span="18">
                        <el-button
                            style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                            @click.stop="downClick('机构')" icon="el-icon-download" size="small">
                            下载机构数据
                        </el-button>
                        <el-button
                            style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                            @click.stop="downClick('HCP')" icon="el-icon-download" size="small">
                            下载HCP数据
                        </el-button>
                        <el-button
                            style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                            @click.stop="downClick('RETAILSTORE')" icon="el-icon-download" size="small">
                            下载门店数据
                        </el-button>
                        <el-button
                            style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                            @click.stop="downClick('DISTRIBUTOR')" icon="el-icon-download" size="small">
                            下载经销商数据
                        </el-button>
                        <el-button
                            style="color: #fff;font-size: 12px;background: #FF9901;border:1px solid #FF9901;border-radius: 5px;"
                            @click.stop="dataActiveClick" icon="el-icon-folder-checked" size="small">
                            数据生效
                        </el-button>
                    </el-col>
                    <el-col :span="6">
                        <span style="color: #2b92fa;float: right;line-height: 32px">采集记录总数：{{sum}}条</span>
                    </el-col>

                </el-row>
                <el-table :data="tableData" border style="width: 100%;margin-top: 20px" stripe>
                    <el-table-column type="index" label="序号" width="55">
                    </el-table-column>
                    <el-table-column prop="reference_obj" sortable label="对象" width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.row.reference_obj == 'HCP'"
                                style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                HCP
                            </span>
                            <span v-if="scope.row.reference_obj == 'INSTITUTION'"
                                style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                机构
                            </span>
                            <span v-if="scope.row.reference_obj == 'RETAILSTORE'"
                                style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                门店
                            </span>
                            <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'"
                                style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                经销商
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="reference_obj" sortable label="客户">
                        <template slot-scope="scope">
                            <span v-if="scope.row.reference_obj == 'HCP'">
                                {{scope.row.institution_name +' | '+scope.row.department +' | '+
                                    scope.row.job_title +' | '+scope.row.hcp_name}}
                            </span>
                            <span v-if="scope.row.reference_obj == 'INSTITUTION'">
                                {{scope.row.institution_name}}
                            </span>
                            <span v-if="scope.row.reference_obj == 'RETAILSTORE'">
                                {{scope.row.store_name}}
                            </span>
                            <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'">
                                {{scope.row.distributor_name}}
                            </span>

                        </template>
                    </el-table-column>
                    <el-table-column prop="fill_num" sortable label="字段数" width="100">
                    </el-table-column>
                    <el-table-column prop="alias" sortable label="提交人" width="120">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.alias">
                                -
                            </span>
                            <span v-else>
                                {{scope.row.alias}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="timestamp" sortable label="提交时间">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.timestamp">
                                -
                            </span>
                            <span v-else>
                                {{scope.row.timestamp}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="80" style="color: #3b99f7">
                        <template slot-scope="scope">
                            <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                size="small" @click="handleDetail(scope.row)">详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </div>
        </div>

        <el-dialog :visible.sync="dialogDetails" width="900px" :show-close="false" style="vertical-align: center;">
            <div style="">
                <el-row style="padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">{{name}}
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <!--                            <el-button type="primary" size="small" @click.stop="add">-->
                            <!--                                保存-->
                            <!--                            </el-button>-->
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-tabs v-model="activeName2">
                    <el-tab-pane label="基本信息" name="first">
                        <div id="collect_field" style="margin-top: 20px;" v-if="insFalse">
                            <el-form :model="insList" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称">
                                            <el-input v-model="insList.institution_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码">
                                            <el-input v-model="insList.institution_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别">
                                            <el-select v-model="insList.institution_type" filterable disabled
                                                placeholder="" style="width: 100%" @change="fangfa2" clearable>
                                                <el-option v-for="item in TypeList" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="insList.institution_grade_name" filterable disabled
                                                placeholder="" style="width: 100%" clearable>
                                                <el-option v-for="item in GardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份">
                                            <el-select v-model="insList.province_id" filterable disabled placeholder=""
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市">
                                            <el-select v-model="insList.city_id" filterable disabled placeholder=""
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="地址">
                                    <el-input v-model="insList.address" disabled></el-input>
                                </el-form-item>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="insList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="insList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="官方网址">
                                            <el-input v-model="insList.website" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属经销商">

                                            <el-select v-model="insList.distributor_id" filterable disabled
                                                placeholder="" style="width: 100%" clearable>
                                                <el-option v-for="item in distributorList" :key="item.distributor_id"
                                                    :label="item.distributor_name" :value="item.distributor_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-form-item label="备注">
                                    <el-input type="textarea" :rows="3" v-model="insList.comments" placeholder=""
                                        disabled></el-input>
                                </el-form-item>


                            </el-form>

                        </div>
                        <div class="HcpClass1" style="margin-top: 20px;" v-if="hcpFalse">
                            <el-form ref="Hcplist" :model="Hcplist" label-width="150px">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="所属科室/部门" prop="standard_dept">
                                            <el-select v-model="Hcplist.standard_dept" placeholder="  " filterable
                                                style="width: 100%" disabled>
                                                <el-option v-for="item in administrative" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="科室挂牌名称" prop="department">
                                            <el-input v-model="Hcplist.department" placeholder=" " disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="姓名">
                                            <el-input v-model="Hcplist.name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="性别">
                                            <el-select v-model="Hcplist.sex" style="width:100%" disabled>
                                                <el-option label="男" value="M"></el-option>
                                                <el-option label="女" value="F"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>

                                    <el-col :span="12">
                                        <el-form-item label="职务">
                                            <el-select v-model="Hcplist.position" filterable style="width:100%" disabled
                                                placeholder="  ">
                                                <el-option v-for="item in jobtList" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="职称">
                                            <el-select v-model="Hcplist.title" filterable style="width:100%" disabled
                                                placeholder="  ">
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>



                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="Hcplist.phone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="电子邮件">
                                            <el-input v-model="Hcplist.mali" disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="生日">
                                            <el-date-picker v-model="Hcplist.brithday" type="date"
                                                value-format="yyyy-MM-dd" placeholder="  " style="width: 100%" disabled>
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="爱好">
                                            <el-input v-model="Hcplist.hobby" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>


                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="主治病症">
                                            <el-input v-model="Hcplist.specialties" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="门诊时间">
                                            <el-input v-model="Hcplist.consulting_hours" placeholder="" disabled>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校">
                                            <el-input v-model="Hcplist.education" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="担任协会职务">
                                            <el-input v-model="Hcplist.fellowships" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="专家讲者">
                                            <el-switch v-model="Hcplist.speaker" active-color="#13ce66" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="讲者级别">
                                            <el-select v-model="Hcplist.speaker_level" placeholder="  "
                                                style="width: 100%" disabled>
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="KOL">
                                            <el-switch v-model="Hcplist.kol" active-color="#13ce66" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="KOL级别">
                                            <el-select v-model="Hcplist.kol_level" placeholder="  " style="width: 100%"
                                                disabled>
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="在职">
                                            <el-switch v-model="Hcplist.status" active-color="#13ce66"
                                                active-value="ACTIVE" inactive-value="INACTIVE" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">

                                        <el-form-item label="HCP编码">
                                            <el-input v-model="Hcplist.hcp_code" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>



                            </el-form>
                        </div>
                        <div class="subjectList" style="margin-top: 20px;" v-if="storeFalse">
                            <el-form ref="storeList" :model="storeList" label-width="150px">

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称" prop="store_name">
                                            <el-input v-model="storeList.store_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码" prop="store_code">
                                            <el-input v-model="storeList.store_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别" prop="store_type">
                                            <el-select v-model="storeList.store_type" placeholder="" disabled
                                                style="width: 100%" @change="getGard" clearable>
                                                <el-option v-for="item in storeTypeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="storeList.retailstore_grade_name" placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in storeGardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份" prop="province_id">
                                            <el-select v-model="storeList.province_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市" prop="city_name">
                                            <el-select v-model="storeList.city_name" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属医疗机构">

                                            <el-select v-model="storeList.institution_id" filterable placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in institutionList" :key="item.institution_id"
                                                    :label="item.institution_name" :value="item.institution_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="地址">
                                            <el-input v-model="storeList.address" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="storeList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="storeList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="官方网址">
                                            <el-input v-model="storeList.website" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属经销商">

                                            <el-select v-model="storeList.distributor_id" filterable placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in storeDistributorList"
                                                    :key="item.distributor_id" :label="item.distributor_name"
                                                    :value="item.distributor_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="备注">
                                    <el-input :rows="3" v-model="storeList.comments" placeholder="" disabled
                                        type="textarea"></el-input>
                                </el-form-item>


                            </el-form>
                        </div>
                        <div class="subjectList" style="margin-top: 20px;" v-if="disFalse">
                            <el-form ref="disList" :model="disList" label-width="150px">

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称" prop="distributor_name">
                                            <el-input v-model="disList.distributor_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码" prop="distributor_code">
                                            <el-input v-model="disList.distributor_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别" prop="distributor_type">
                                            <el-select v-model="disList.distributor_type" placeholder="" disabled
                                                style="width: 100%" @change="fangfa3" clearable>
                                                <el-option v-for="item in disTypeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="disList.distributor_grade_name" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in disGardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份" prop="province_id">
                                            <el-select v-model="disList.province_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市" prop="city_id">
                                            <el-select v-model="disList.city_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="地址">
                                    <el-input v-model="disList.address" disabled></el-input>
                                </el-form-item>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="disList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="disList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-form-item label="官方网址">
                                    <el-input v-model="disList.website" disabled></el-input>
                                </el-form-item>

                                <el-form-item label="备注">
                                    <el-input v-model="disList.comments" placeholder="" disabled type="textarea">
                                    </el-input>
                                </el-form-item>


                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="采集字段" name="second">
                        <div class="subjectList" style="margin-top: 20px;">
                            <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in extendedInfo" :model="item"
                                :key="item.field_id">
                                <el-col span="24" v-if="item.input_type == 'TEXT'">
                                    <el-form-item :label="item.label">
                                        <el-input v-model="item.field_value" placeholder="请输入文本" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                                    <el-form-item :label="item.label">
                                        <el-input v-model="item.field_value" placeholder="请输入数字" type="number" disabled>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                                    <el-form-item :label="item.label">
                                        <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间"
                                            style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                    <el-form-item :label="item.label">
                                        <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T"
                                            inactive-value="F" disabled>
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                                    <el-form-item :label="item.label">

                                        <el-cascader v-model="item.field_value" :options="item.listArray"
                                            style="width: 100%" filterable :show-all-levels="false"
                                            :disabled="item.readonly == 'T'"
                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                            clearable></el-cascader>
                                    </el-form-item>
                                </el-col>

                                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                                    <el-form-item :label="item.label">
                                        <el-table :data="item.field_value" border style="width: 100%">
                                            <el-table-column type="index" label="序号" width="50">
                                            </el-table-column>
                                            <el-table-column prop="date_name" label="标准科室"
                                                v-if="item.array_dept !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="product_name" label="产品"
                                                v-if="item.array_product !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="sku_name" label="SKU"
                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="date_name" label="日期"
                                                v-if="item.array_date !== 'NONE' ">
                                            </el-table-column>
                                            <el-table-column prop="field_value" label="数值">
                                            </el-table-column>
                                        </el-table>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" @change="getExtendedInfoCity" disabled
                                            style="width: 100%" placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_INS'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoInsType" disabled placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_STO'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoStoType" disabled placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_DIS'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoDisType" disabled placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT2'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%" disabled
                                            placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col span="24" v-else>
                                    <el-form-item :label="item.label">
                                        <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息"
                                            type="textarea" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form>
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </div>

        </el-dialog>

        <el-dialog :visible.sync="dialogDetails1" width="600px" :show-close="false" style="vertical-align: center;">
            <div style="">
                <el-row style="padding-bottom: 20px;border-bottom: 2px dotted #e7eaec;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">采集数据生效
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <p style="text-align: center;color: #2b92fa;margin-top: 44px;">将本次采集的客户数据更新到正式的主数据库中
                        <el-button
                            style="color: #fff;font-size: 12px;background: #FF9901;border:1px solid #FF9901;border-radius: 5px;"
                            @click.stop="nowUpload" size="small">
                            立即更新
                        </el-button>
                    </p>
                </el-row>
            </div>

        </el-dialog>

    </el-row>
</template>

<script>
    import collectionBar from '../../../components/collectionBar'
    import pagination from '../../../components/pagination'
    import http from "../../../APIService/http";
    import moment from "moment";
    import { Message } from "element-ui";
    export default {
        name: "collectData",
        data() {
            return {
                tags: ['数据采集任务', '采集数据'],
                subTitle: '',
                channelCheckList: [],
                tableData: [
                ],
                objList: ['HCP', 'INSTITUTION', 'RETAILSTORE', 'DISTRIBUTOR'],
                insList: {
                    institution_name: "",
                    institution_code: "",
                    institution_type: "",
                    institution_grade_name: "",
                    province_id: '',
                    city_id: "",
                    address: "",
                    telephone: "",
                    postcode: "",
                    website: "",
                    distributor_id: "",
                    comments: "",
                    status: "ACTIVE",
                },
                Hcplist: {
                    hcp_code: '',
                    status: 'ACTIVE',
                    kol_level: '',
                    kol: '',
                    speaker_level: '',
                    speaker: '',
                    fellowships: '',
                    education: '',
                    consulting_hours: '',
                    specialties: '',
                    hobby: '',
                    brithday: '',
                    mali: '',
                    phone: '',
                    title: '',
                    position: '',
                    sex: '',
                    name: '',
                    department: '',
                    standard_dept: ''
                },
                storeList: {
                    store_name: '',
                    store_code: '',
                    store_type: '',
                    retailstore_grade_name: '',
                    province_id: '',
                    city_name: '',
                    institution_id: '',
                    address: '',
                    telephone: '',
                    postcode: '',
                    website: '',
                    distributor_id: '',
                    comments: '',
                    status: 'ACTIVE'
                },
                disList: {
                    distributor_name: '',
                    distributor_code: '',
                    distributor_type: '',
                    distributor_grade_name: '',
                    province_id: '',
                    city_id: '',
                    address: '',
                    telephone: '',
                    postcode: '',
                    website: '',
                    comments: '',

                },
                TypeList: [],
                GardeList: [],
                distributorList: [],
                dialogDetails: false,
                dialogDetails1: false,
                activeName2: 'first',
                collectProfile: [],
                task_id: '',
                owner_id: '',
                customer_name: '',
                peopleList: [],
                provinceList: [],
                province_id: '',
                cityList: [],
                city_id: '',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                sum: 0,
                insFalse: false,
                hcpFalse: false,
                storeFalse: false,
                disFalse: false,
                name: '',
                administrative: [],
                jobtList: [],
                prolist: [],
                storeTypeList: [],
                storeGardeList: [],
                institutionList: [],
                storeDistributorList: [],
                extendedInfo: [],
                arrayCont: [],
                disGardeList: [],
                disTypeList: []

            }
        },


        components: {
            collectionBar,
            pagination,
        },
        created() {
            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
            this.task_id = this.collectProfile.task_id
            this.subTitle = this.collectProfile.task_name
            this.getPeopleList()
            this.getProvinceList()
            this.getCity()
            this.init()
            this.getItitutionTypeList()
            this.getStandardDeptList()
            this.getDistributorTypeList()
            this.getJobtList()
            this.getProList()

            this.getRetailstoreTypeList()

        },
        methods: {
            handleBackClick() {
                this.$router.push({ name: 'CollectionHome' })
            },
            async getItitutionTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getItitutionTypeList', data).then(res => {

                    if (res.success) {
                        self.TypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            fangfa2(b) {
                this.insList.institution_grade_name = ''
                this.getItitutionGardeList(b)
            },
            fangfa3(b) {
                this.disList.distributor_grade_name = ''
                this.getDistributorGardeList(b)
            },
            async getItitutionGardeList(b) {

                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b

                }

                let self = this
                await http.post('/wapi/Institution/getItitutionGardeList', data).then(res => {

                    if (res.success) {
                        self.GardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },

            async getDistributorTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorTypeList', data).then(res => {

                    if (res.success) {
                        self.disTypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getDistributorGardeList(b) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorGardeList', data).then(res => {

                    if (res.success) {
                        self.disGardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            async getPeopleList() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    user_id: user.user_id
                }
                await http.post('/wapi/Collect/getPeopleList', data).then(res => {
                    if (res.success) {
                        this.peopleList = res.data
                    }
                })
            },
            getProvinceList() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id
                }
                http.post('/wapi/Province/getProvinceList', data).then(res => {
                    if (res.success) {
                        this.provinceList = res.data
                    }
                })
            },
            getCityList(e) {
                this.city_id = ''
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    province_id: e
                }
                http.post('/wapi/City/getCityList', data).then(res => {
                    if (res.success) {
                        this.cityList = res.data
                    }
                })
            },
            getCity() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                }
                http.post('/wapi/City/getCityList1', data).then(res => {
                    if (res.success) {
                        this.CityList = res.data
                    }
                })
            },
            async init() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.task_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        reference_obj: this.channelCheckList,
                        province_id: this.province_id,
                        city_id: this.city_id,
                        customer_name: this.customer_name,
                        owner_id: this.owner_id
                    }
                    await http.post('/wapi/Collect/getCollectionTaskInfo', data).then(res => {


                        this.tableData = res.data.array
                        this.tableData.forEach(item => {
                            if (item.time) {
                                item.timestamp = moment(item.time).format('YYYY年MM月DD日')
                            }

                        })
                        this.sum = res.data.arrayCont.length
                        this.page.total = res.data.arrayCont.length
                        this.arrayCont = res.data.arrayCont
                        this.arrayCont.forEach(item => {
                            if (item.reference_obj == 'INSTITUTION') {
                                item.reference_obj = '机构'
                                item.customer_name = item.institution_name
                            } else if (item.reference_obj == 'HCP') {
                                item.customer_name = item.institution_name + ' | ' + item.department + ' | ' + item.job_title + ' | ' + item.hcp_name
                            } else if (item.reference_obj == 'RETAILSTORE') {
                                item.reference_obj = '门店'
                                item.customer_name = item.store_name
                            } else if (item.reference_obj == 'DISTRIBUTOR') {
                                item.reference_obj = '经销商'
                                item.customer_name = item.distributor_name
                            }
                            if (item.time) {
                                item.timestamp = moment(item.time).format('YYYY年MM月DD日')
                            }

                        })
                        loading.close()

                    })

                } catch (e) {
                    loading.close()
                }

            },
            handleQueryClick() {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                },
                    this.objList = JSON.parse(JSON.stringify(this.channelCheckList))
                this.init()

            },
            nowUpload() {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        task_id: this.task_id,
                        reference_obj: this.objList
                    }
                    http.post('/wapi/Collect/nowUpload', data).then(res => {
                        if (res.success) {
                            this.$message({
                                type: 'success',
                                message: '更新成功'
                            })
                            loading.close()
                        }
                    })

                } catch (e) {
                    loading.close()
                }
            },
            async getStandardDeptList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getStandardDeptList', data).then(res => {

                    if (res.success) {
                        self.administrative = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getJobtList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getJobtList', data).then(res => {

                    if (res.success) {
                        self.jobtList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getProList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getProList', data).then(res => {

                    if (res.success) {
                        self.prolist = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getInstitution(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    store_id: a
                }
                await http.post('/wapi/Collect/getInstitution', data).then(res => {

                    if (res.success) {
                        this.institutionList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getStoreDistributorList(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    store_id: a
                }
                await http.post('/wapi/Collect/getStoreDistributorList', data).then(res => {

                    if (res.success) {
                        this.storeDistributorList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getRetailstoreTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreTypeList', data).then(res => {

                    if (res.success) {
                        self.storeTypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            getGard(b) {
                this.storeList.retailstore_grade_name = ''
                this.getRetailstoreGardeList(b)
            },
            async getRetailstoreGardeList(b) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b
                }
                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreGardeList', data).then(res => {

                    if (res.success) {
                        self.storeGardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getCollectionFieldList(row) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id: this.task_id,
                    institution_id: row.institution_id,
                    hcp_id: row.hcp_id,
                    store_id: row.store_id,
                    distributor_id: row.distributor_id,
                    reference_obj: row.reference_obj
                }
                await http.post('/wapi/Collect/getCollectionFieldList', data).then(res => {
                    if (res.success) {
                        this.extendedInfo = res.data
                        this.extendedInfo.forEach(item => {
                            if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                                item.field_value = [item.field_value]
                            }
                            if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                                item.field_value = item.field_value.split('|')
                            }
                            if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                                item.field_value = []
                            }
                            if (item.input_type === "TABLE" && item.field_value !== '') {
                                item.field_value = JSON.parse(item.field_value)
                            }
                            if (item.input_type === "TABLE" && item.field_value === '') {
                                item.field_value = []
                            }
                            if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                                item.field_value = 'F'
                            }


                        })
                    }
                })
            },


            downClick(type) {
                this.handleExportData(type)
            },
            dataActiveClick() {
                this.dialogDetails1 = true
            },
            handleExportData(type) {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    //
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['对象', '客户', '字段数', '提交人', '提交时间']
                        const filterVal = [
                            'reference_obj',
                            'customer_name',
                            'fill_num',
                            'alias',
                            'timestamp'
                        ]
                        let list = [];
                        for (const _item of this.arrayCont) {
                            if (_item.reference_obj === type) {
                                list.push(_item);
                            }
                        }
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '采集数据',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },


            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            handleResetClick() {
                this.channelCheckList = []
                this.province_id = ''
                this.city_id = ''
                this.customer_name = ''
            },
            handleDetail(row) {
                this.activeName2 = 'first'
                this.getCollectionFieldList(row)
                if (row.reference_obj == 'INSTITUTION') {
                    this.insFalse = true
                    this.hcpFalse = false
                    this.storeFalse = false
                    this.disFalse = false
                    this.name = '机构详情'
                    this.getInstitutionInfo(row.institution_id)
                    this.getDistributorList(row.institution_id)
                    this.dialogDetails = true
                } else if (row.reference_obj == 'HCP') {
                    this.insFalse = false
                    this.hcpFalse = true
                    this.storeFalse = false
                    this.disFalse = false
                    this.name = 'HCP详情'
                    this.getHcpInfo(row.hcp_id)
                    this.dialogDetails = true
                } else if (row.reference_obj == 'RETAILSTORE') {
                    this.insFalse = false
                    this.hcpFalse = false
                    this.storeFalse = true
                    this.disFalse = false
                    this.name = '门店详情'
                    this.getInstitution(row.store_id)
                    this.getStoreDistributorList(row.store_id)
                    this.getStoreList(row.store_id)
                    this.dialogDetails = true
                } else if (row.reference_obj == 'DISTRIBUTOR') {
                    this.insFalse = false
                    this.hcpFalse = false
                    this.storeFalse = false
                    this.disFalse = true
                    this.name = '经销商详情'
                    this.getDistributorInfo(row.distributor_id)
                    this.dialogDetails = true
                }

            },
            getInstitutionInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    institution_id: a

                }
                http.post('/wapi/Institution/getInstitutionInfo', data).then(res => {
                    if (res.success) {
                        this.insList = {
                            institution_name: res.data[0].institution_name,
                            institution_code: res.data[0].institution_code,
                            institution_type: res.data[0].institution_type,
                            institution_grade_name: res.data[0].institution_grade_name,
                            province_id: res.data[0].province_id,
                            city_id: res.data[0].city_id,
                            address: res.data[0].address,
                            telephone: res.data[0].telephone,
                            postcode: res.data[0].postcode,
                            website: res.data[0].website,
                            distributor_id: res.data[0].distributor_id,
                            comments: res.data[0].comments,
                            status: res.data[0].status,
                        }


                    }
                })

            },
            getDistributorList(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    institution_id: a
                }
                http.post('/wapi/Collect/getDistributorList', data).then(res => {
                    if (res.success) {
                        this.distributorList = res.data
                    }
                })
            },
            getHcpInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    hcp_id: a
                }
                http.post('/wapi/Collect/getHcpInfo', data).then(res => {
                    if (res.success) {
                        console.log(res.data)
                        this.Hcplist = {
                            hcp_code: res.data[0].hcp_code,
                            status: res.data[0].status,
                            kol_level: res.data[0].kol_level,
                            kol: res.data[0].kol,
                            speaker_level: res.data[0].speaker_level,
                            speaker: res.data[0].speaker,
                            fellowships: res.data[0].fellowships,
                            education: res.data[0].education,
                            consulting_hours: res.data[0].consulting_hours,
                            specialties: res.data[0].specialties,
                            hobby: res.data[0].hobby,
                            brithday: res.data[0].birthday,
                            mali: res.data[0].email,
                            phone: res.data[0].office_phone,
                            title: res.data[0].pro_title_id,
                            position: res.data[0].job_title_id,
                            sex: res.data[0].gender,
                            name: res.data[0].hcp_name,
                            department: res.data[0].department,
                            standard_dept: res.data[0].standard_dept
                        }

                    }
                })
            },
            getStoreList(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    store_id: a
                }
                let self = this
                http.post('/wapi/Retailstore/getRetailstoreInfo', data).then(res => {
                    if (res.success) {
                        self.storeList.address = res.data[0].address
                        self.storeList.city_id = res.data[0].city_id
                        self.storeList.city_name = res.data[0].city_name
                        self.storeList.comments = res.data[0].comments
                        self.storeList.lat = res.data[0].lat
                        self.storeList.lng = res.data[0].lng
                        self.storeList.location_id = res.data[0].location_id
                        self.storeList.postcode = res.data[0].postcode
                        self.storeList.province_id = res.data[0].province_id
                        self.storeList.province_name = res.data[0].province_name
                        self.storeList.retailstore_grade = res.data[0].retailstore_grade
                        self.storeList.retailstore_grade_name = res.data[0].retailstore_grade_name
                        self.storeList.province_name = res.data[0].province_name
                        self.storeList.store_id = res.data[0].store_id
                        self.storeList.store_name = res.data[0].store_name
                        self.storeList.store_type = res.data[0].store_type
                        self.storeList.store_type_name = res.data[0].store_type_name
                        self.storeList.tenant_id = res.data[0].tenant_id
                        self.storeList.website = res.data[0].website
                        self.storeList.telephone = res.data[0].telephone
                        self.storeList.store_code = res.data[0].store_code
                    }
                })

            },
            getDistributorInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    distributor_id: a
                }
                let self = this
                http.post('/wapi/Distributor/getDistributorInfo', data).then(res => {
                    if (res.success) {
                        self.disList.address = res.data[0].address
                        self.disList.city_id = res.data[0].city_id
                        self.disList.city_name = res.data[0].city_name
                        self.disList.comments = res.data[0].comments
                        self.disList.distributor_grade = res.data[0].distributor_grade
                        self.disList.distributor_grade_name = res.data[0].distributor_grade_name
                        self.disList.distributor_id = res.data[0].distributor_id
                        self.disList.distributor_name = res.data[0].distributor_name
                        self.disList.distributor_type = res.data[0].distributor_type
                        self.disList.distributor_type_name = res.data[0].distributor_type_name
                        self.disList.lat = res.data[0].lat
                        self.disList.lng = res.data[0].lng
                        self.disList.location_id = res.data[0].location_id
                        self.disList.postcode = res.data[0].postcode
                        self.disList.province_id = res.data[0].province_id
                        self.disList.province_name = res.data[0].province_name
                        self.disList.telephone = res.data[0].telephone
                        self.disList.tenant_id = res.data[0].tenant_id
                        self.disList.website = res.data[0].website
                        self.disList.distributor_code = res.data[0].distributor_code
                    }
                })
            },
            add() {

            },
            close() {

                this.dialogDetails = false
                this.dialogDetails1 = false
            }
        }
    }
</script>

<style scoped>
    #collectData>>>.el-dialog__header {
        padding-top: 0
    }

    #collectData>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
        text-align: left;
        padding-left: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/collectData.vue